export function setFaqs({ commit }, payload) {
  commit('setFaqs', payload);
}

export function clearFaqs({ commit }) {
  commit('clearFaqs');
}
